import * as React from 'react';
import { Header2, InlineText1, InlineText2, Button } from '@cian/ui-kit';
import imageSuccess from './assets/success.png';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Success(_ref) {
  var newbuildingName = _ref.newbuildingName,
    dateTime = _ref.dateTime,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx("img", {
        width: "64",
        height: "64",
        src: imageSuccess
      })
    }), /*#__PURE__*/_jsx(Header2, {
      children: "\u0412\u044B \u0437\u0430\u043F\u0438\u0441\u0430\u043B\u0438\u0441\u044C \u043D\u0430 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440!"
    }), /*#__PURE__*/_jsx("div", {
      className: styles['info'],
      children: /*#__PURE__*/_jsxs(InlineText1, {
        children: [newbuildingName, /*#__PURE__*/_jsx("br", {}), dateTime]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['message'],
      children: /*#__PURE__*/_jsxs(InlineText2, {
        color: "gray60_100",
        children: ["\u0412 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0432\u0430\u043C \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442", /*#__PURE__*/_jsx("br", {}), "\u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0437\u0430\u043F\u0438\u0441\u0438"]
      })
    }), /*#__PURE__*/_jsx(Button, {
      size: "M",
      onClick: onClick,
      children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"
    })]
  });
}